import {NinchatState} from 'api/types'

export const isRealmOwnerOrOperator = (ninchat: NinchatState, realmId?: string): boolean => {
    if (!realmId) {
        return false
    }

    const {
        user_realms, user_realms_member, user_id,
    } = ninchat
    const isOwner = user_realms?.[realmId]?.realm_attrs?.owner_id === user_id
    const realmMember = user_realms_member?.[realmId]
    const isOperator = realmMember ? !!realmMember.operator : false
    return isOwner || isOperator
}
